/* eslint-disable max-depth */
import moment from 'moment-timezone';
import _ from 'lodash';
import apis from 'src/const/apis';
import { comingSourceType } from 'src/const/coming_source_type';
import {
  formatAge, formatAc, formatPlatForm, splitTestType, REFERER,
} from 'src/const/state/campaign';

import request from 'src/utils/request';
import tool from 'src/utils/tool';
import * as types from 'src/store/types';
import { updateAndCheckUserCreativeDraft, submitDraftAndSaved } from 'src/service/simplifiedSmb';
import { submitResultAdapt } from 'src/utils/simplifyForSmbInCreative';
import { isCreativeHasIdentityWhite } from 'src/const/whiteList';
import { bcIdentityTypesList } from 'src/const/state/creative';
import adcampaign from './adcampaign';
import adgroup from './adgroup';

function getAcoHasVideo(imageList) {
  return !!imageList?.some(item => item.video_info);
}

const SET_PERF_OPERATED_ANCHOR = `perf/${types.SET_PERF_OPERATED_ANCHOR}`;

export default {
  namespaced: true,
  modules: {
    adcampaign,
    adgroup,
  },
  state: {
    partnerList: [],
    campaignIds: {},
    campaignIdForSplittest: -1,
    adgroupIdForSplittest: -1,
    abtestFlagForSplittest: 0, // -1: 开启 0:未开启 1:受众 2:创意 3:优化目标

    // 点击第三层级导航或者 tab 时候触发这个地方的修改
    activeThirdTabs: {
      parents: '',
      itemIndex: 0,
      name: '',
    },
    paramsAudienceEstimate: {}, // 存储的受众预估参数
    referer: {}, // 创编来源 [tt_store_manager]
    isFromSimpilified_05: false, // 判断当前campaign是否来自simpilified
    isFromConversion: false, // 判断是否由lite的conversion跳来
    needModeSwitchTooltip: false, // 判断切换模式时是否需要tooltip
  },

  getters: {
    modelKey(state, getters, rootState) {
      const permissionData = rootState.account.permissionData || {};
      const loginId = permissionData?.account?.id || '0';
      const visitorId = permissionData?.core_user?.core_user_id || '0';
      return `${loginId}:${visitorId}`;
    },
    hasReferer(state) {
      return state.referer?.value !== undefined;
    },
    // 判断当前campaign是否来自store_manager
    isStoreManagerReferer(state) {
      return state.referer?.value === REFERER.STORE_MANAGER.value;
    },
    // 判断当前campaign是否来自Magellan seller center
    isMagellanReferer(state) {
      return state.referer?.value === REFERER.MAGELLAN.value;
    },
    // 判断当前campaign 是否来自 pixel switch now
    isSwitchNowReferer(state) {
      return state.referer?.value === REFERER.SWITCH_TO_CONVERSION_SHORTCUT.value;
    },
  },

  mutations: {
    [types.SET_PARTNER_LIST](state, data) {
      state.partnerList = data;
    },
    [types.SET_ACK_CAMPAIGN_IDS](state, data = {}) {
      state.campaignIds = data;
    },
    [types.SET_CAMPAIGN_ID_FOR_SPLITTEST](state, data) {
      state.campaignIdForSplittest = data;
    },
    [types.SET_ADGROUP_ID_FOR_SPLITTEST](state, data) {
      state.adgroupIdForSplittest = data;
    },
    [types.SET_ABTEST_FLAG_FOR_SPLITTEST](state, data) {
      state.abtestFlagForSplittest = data;
    },
    [types.SET_ACTIVE_THIRD_TABS](state, data = {}) {
      state.activeThirdTabs = data;
    },
    [types.SET_PARAMS_AUDIENCE_ESTIMATE](state, data = {}) {
      state.paramsAudienceEstimate = data;
    },
    [types.SET_REFERER](state, data = {}) {
      state.referer = data;
    },
    [types.CLEAR_REFERER](state) {
      state.referer = {};
    },
    [types.SET_ISFROMSIMPLIFIED05](state, data) {
      state.isFromSimpilified_05 = data;
    },
    [types.SET_ISFROMCONVERSION](state, data) {
      state.isFromConversion = data;
    },
    [types.SET_NEED_MODE_SWITCH_TOOLTIP](state, data) {
      state.needModeSwitchTooltip = data;
    },
  },

  actions: {
    updatePoNumber({ commit }, data) {
      commit(SET_PERF_OPERATED_ANCHOR, {}, { root: true });
      return request.post(apis.campaign.updatePoNumber, data);
    },

    updateBudget({ commit }, data) {
      commit(SET_PERF_OPERATED_ANCHOR, {}, { root: true });
      return request.post(apis.campaign.updateBudget, data);
    },

    // 获取所有 campaign
    getAllCampaign({ commit }, data) {
      return request.get(apis.campaign.nav_list, data);
    },

    // 获取第三方监测链接合作伙伴列表
    getPartnerList({ commit }, data) {
      return request.get(apis.toolbox.partnerList, data).then(({ data }) => {
        commit(types.SET_PARTNER_LIST, data.partner);
      });
    },

    // 获取应用信息，已废弃
    getAppInfo(store, data) {
      return request.get(apis.toolbox.appInfo, data);
    },

    // 触发后端应用信息获取
    triggerPackageParse(store, data) {
      return request.postForm(apis.ad.package_parse, data);
    },

    // 触发列表中没有 app 信息的转化获取 app 信息
    updateAppInfo(store, data) {
      return request.post(apis.toolbox.appInfoUpdate, data);
    },

    // 修改 toggle 状态
    updateCampaignStatus({ commit }, data) {
      commit(SET_PERF_OPERATED_ANCHOR, {}, { root: true });
      return request.postForm(apis.campaign.update_status, data);
    },
    updateConvertStatus(store, data) {
      return request.post(apis.toolbox.convert_update_status, data);
    },

    // 创建转化工具
    createConversion(store, data) {
      return request.post(apis.toolbox.convert_create, data);
    },
    // 更新转化工具
    updateConversion(store, data) {
      return request.post(apis.toolbox.conversionUpdate, data);
    },

    // 新建竞价广告提交新建和复制
    async submitCampaign(
      store,
      {
        isCopy = false,
        isCopyCreative = false,
        isProcedural = false,
        creativeMaterialMode,
        isNewStructure,
        comingSourceType, // 广告创建的来源标识
        isEngagementFans,
        creativeInfoWithCta,
        isTrackApp,
      },
    ) {
      const {
        state, dispatch, rootState, rootGetters,
      } = store;

      let adId = '';
      let adName = '';
      let campaignId = '';
      let campaignName = '';
      // 复制弹窗的adgroup数据
      const publishReport = {
        campaign: {},
        adgroup: [],
        ad: [],
      };
      if (isCopy) {
        ({ campaign_id: campaignId = '' } = state.adgroup);
        if (isCopyCreative) {
          const { adgroupData = {}, adgroupInfo = {}, fakeAdIds = [] } = state.adgroup;
          adName = adgroupData.name || adgroupInfo.name || '';
          // 有 fakeAdIds 是将现有创意复制到一个新 adgroup 中
          // 没有 fakeAdIds 是将现有创意复制到一个已有的 adgroup 中
          adId = fakeAdIds.length ? '' : state.adgroup.ad_id;
        }
      } else {
        ({ ad_id: adId = '', campaign_id: campaignId = '' } = rootState.route.query);
      }
      const campaignFormData = state.adcampaign.campaignSaved || {};
      campaignName = campaignFormData.campaign_name || '';
      publishReport.campaign = {
        campaign_name: campaignName || '',
        campaign_id: campaignId || '',
        status: 1,
        msg: '',
      };
      // 第 1 步 campaign 数据提交 ==>
      // 当没有 campaignId 的时候，请求 campaign 新建的接口
      if (!campaignId) {
        try {
          const risk_info = tool.getRiskInfo();
          const { data } = await dispatch('adcampaign/createCampaign', { ...campaignFormData, coming_source_type: comingSourceType, risk_info });
          if (!data || !data.campaign_id) {
            return { status: false, item: 'campaign', report: publishReport };
          }
          campaignId = data.campaign_id;
          publishReport.campaign_id = campaignId;
        } catch (e) {
          return {
            status: false, item: 'campaign', report: publishReport, rejectCode: e?.message,
          };
        }
      }

      // 第 2 步 ===>
      // 提交新建的单个计划 , https://wiki.bytedance.net/pages/viewpage.action?pageId=253373699
      let adIds = adId ? [adId] : [];
      const creativeBatchInfo = [];
      let batchInfo = [];
      // 当没有 adId 的时候，请求 adGroup 新建的接口
      // adgroup 复制的逻辑
      if (adIds.length === 0) {
        try {
          const adgroupData = { ...state.adgroup.adgroupData } || {}; // 已经合并完成的数据
          if (adgroupData.language_list.length && adgroupData.language_list[0] === 'all') {
            adgroupData.language_list = [];
          }
          if (adgroupData.age.length && adgroupData.age[0] === 'ALL') {
            adgroupData.age = [];
          } else {
            adgroupData.age = formatAge(adgroupData.age);
          }
          adgroupData.ac = formatAc(adgroupData.ac);
          adgroupData.platform = formatPlatForm(adgroupData.platform);
          if (isCopy) {
            batchInfo = [...state.adgroup.batchInfo] || [];
          }

          // create 时候处理 split test 的情况，TODO：目前只有 target 一种情况
          if (rootGetters['campaign/adgroup/useTargetSplitTest']) {
            adgroupData.ab_test = splitTestType.TARGET;

            batchInfo = state.adgroup.targetMultiTabs.map((item, index) => {
              const vars = rootState.campaign.adgroup.splitTestVars[index];
              const inventory_flow = rootState.campaign.adgroup.splitTestVars[index].inventory_flow.filter(item => item !== '2000') || [];
              return {
                ...vars,
                inventory_flow,
                name: adgroupData.name + item.value,
                platform: formatPlatForm(vars.platform),
                num: index + 1,
                age: formatAge(vars.age),
                ios_osv: vars.ios_osv ? +vars.ios_osv : vars.ios_osv, // 注意创建和受众获取的字段格式不同
                android_osv: vars.android_osv ? +vars.android_osv : vars.android_osv, // 注意创建和受众获取的字段格式不同
              };
            });
          } else if (rootGetters['campaign/adgroup/useCreativeSplitTest']) {
            // 即使是创意层级split test，adgroup的数据也需要构造batch_info. 创意层级有多少个实验组，这里的batch_info就有多少个元素
            adgroupData.ab_test = splitTestType.CREATIVE;
            batchInfo = rootGetters['creative/create/batchInfo'].map((item, index, arr) => ({
              name: adgroupData.name + tool.numBasedChar(index), // 0 -> A, 1->B
              num: index + 1,
            }));
          } else if (rootGetters['campaign/adgroup/useBiddingSplitTest']) {
            adgroupData.ab_test = splitTestType.OPTIMIZE;

            batchInfo = state.adgroup.biddingMultiTabs.map((item, index) => {
              const vars = rootState.campaign.adgroup.splitTestVars[index];
              return {
                ...vars,
                name: adgroupData.name + item.value,
                num: index + 1,
              };
            });
          }
          delete adgroupData.splitTestTarget;
          delete adgroupData.splitTestBidding;
          delete adgroupData.ad_id;
          adgroupData.campaign_id = campaignId;
          publishReport.adgroupData = { // 建议出价埋点需要用着两个
            bid: adgroupData.bid,
            cpa_bid: adgroupData.cpa_bid,
          };
          adgroupData.coming_source_type = comingSourceType;
          const { data } = await dispatch('adgroup/submitCreateAdgroup', { batch_info: batchInfo, base_info: adgroupData });

          // 定向推荐埋点
          dispatch('adgroup/sendTargetRecommendTrace', data?.ad_ids);

          // 预算推荐埋点
          dispatch('adgroup/returnRecommendBudget', { adId: (data?.ad_ids ?? [''])[0], campaignId });

          if (isCopy && data) {
            const respBatchInfo = data.ad_report || []; // 返回必须和batchInfo数组一样长度
            for (let i = 0; i < batchInfo.length; i++) {
              const item = Object.assign({}, batchInfo[i]); // 深度复制
              item.creative_status = 0; // 创意先设置0，提交后回填
              const respItem = { ...respBatchInfo[i] };
              const newItem = {
                ...item,
                ...respItem,
                campaign_id: campaignId || '',
              }; // 更新adgroup的status
              batchInfo[i] = { ...newItem };
              // status=1 成功, 0 失败,找出提交成功的发给creativeBatchInfo
              if (+newItem.status === 1) {
                creativeBatchInfo.push({
                  num: newItem.num, // 根据num更新 creative
                  name: newItem.name,
                  ad_id: newItem.ad_id || '',
                  status: 1,
                });
              }
            }
            publishReport.adgroup = batchInfo;
            data.ad_ids && data.ad_ids.forEach(ad_id => Vue.prototype.trackEvent(
              'copy_adgroup_source', { ad_id, source_ad_id: rootState.campaign.adgroup.ad_id },
            ));
          }
          if (!data || !data.ad_ids) {
            return { status: false, item: 'adgroup', report: publishReport };
          }
          adIds = data.ad_ids;
        } catch (e) {
          return {
            status: false, item: 'adgroup', report: publishReport, rejectCode: e?.message,
          };
        }
      } else if (isCopyCreative) {
        batchInfo = [
          {
            ad_id: adId,
            name: adName,
            campaign_id: campaignId,
            campaign_name: campaignName,
            status: 1,
            num: 1,
          },
        ];
        publishReport.adgroup = batchInfo;
      }
      // 第 3 步 ===>
      // Ad 提交，接口返回数据中的 ad_and_creative_ids 为第四步中需要的全部数据
      const { inventory_flow: inventoryFlow, objective_type: objectiveType } = state.adgroup;
      let creativeData = {
        coming_source_type: comingSourceType,
        ad_ids: adIds,
        inventory_flow: inventoryFlow,
        objective_type: objectiveType,
        creative_material_mode: creativeMaterialMode, // 与adgroup层级的取值保持一致
        ...rootGetters['creative/playable-card-form/formData'], // 试玩表单贡献的提交参数
      };

      // 自定义创意
      if (!isProcedural) {
        // splittest 创意
        if (rootGetters['campaign/adgroup/useCreativeSplitTest']) {
          const batchInfoWithoutPlayableUrl = rootGetters['creative/create/batchInfo'];
          // 为batchInfo挂上playableUrl
          creativeData.batch_info = batchInfoWithoutPlayableUrl.map((item, index) => {
            const playableUrlList = creativeData.playable_url;
            return { ...item, playable_url: playableUrlList[index] };
          });
        } else {
          creativeData.creative_info = isCopyCreative
            ? rootGetters['creative/create/copyCreativeInfo']
            : rootGetters['creative/create/creativeInfo'];

          Object.keys(creativeInfoWithCta).forEach((materialType) => {
            if (creativeInfoWithCta[materialType] && creativeInfoWithCta[materialType].length > 0) {
              creativeInfoWithCta[materialType].forEach((item, index) => {
                _.set(creativeData, `creative_info.${materialType}[${index}].call_to_action`, item.call_to_action);
                _.set(creativeData, `creative_info.${materialType}[${index}].call_to_action_id`, item.call_to_action_id);
              });
            }
          });

          if (isEngagementFans) {
            creativeData.creative_info.video_list = creativeData.creative_info.video_list.map(item => ({
              ...item,
              call_to_action: '',
              call_to_action_id: '',
              open_url: '',
              is_open_url: 0,
            }));
          }
          if (isTrackApp) {
            creativeData.creative_info.video_list = creativeData.creative_info.video_list.map(item => ({
              ...item,
              external_url: '',
            }));
          }
        }
      } else {
        // 程序化创意
        creativeData = {
          ...creativeData,
          ...rootGetters['creative/procedural-creative-form/formData'],
          struct_version: isNewStructure ? 1 : 0,
        };
        if (isTrackApp) {
          creativeData.external_url = '';
        }
        // 使用CTA优选，则清空CTA 列表的值
        if (creativeData.call_to_action_id) {
          creativeData.call_to_action_list = [];
        }
        // 如果无视频则素材授权字段置为 false
        const isAcoHasVideo = getAcoHasVideo(creativeData.image_list);
        if (!isAcoHasVideo) {
          creativeData.is_creative_authorized = false;
        }

        // 删除create接口中的无用字段
        delete creativeData.isSignProtocol;
        delete creativeData.showProtocolTerms;


        /** ---- identity相关字段处理 ---- */
        delete creativeData.identity_data;

        if (!isCreativeHasIdentityWhite()) {
          delete creativeData.identity_id;
          delete creativeData.identity_type;
        }

        if (!bcIdentityTypesList.includes(creativeData.identity_type)) {
          // 只有bc原生创意有 identity_bc_id
          delete creativeData.identity_bc_id;
        }
      }
      if (isCopy) {
        creativeData.batch_info = creativeBatchInfo;
      }
      // 如果没有使用 creative 类型 split test，
      // 则应将待提交数据的playable_url参数从数组变为数组第一个元素
      // 因为split test在vuex中按照数组存储
      if (!rootGetters['campaign/adgroup/useCreativeSplitTest']) {
        creativeData.playable_url
          && (creativeData.playable_url = creativeData.playable_url[0]);
      } else {
        // 如果使用 creative 类型 split test，
        // 则将待提价数据外层playable_url参数清除，
        // playable_url已被放置在batchInfo中
        creativeData.playable_url = undefined;
      }
      let finalData = null;
      try {
        const { data } = await dispatch('creative/create/uploadAds', creativeData, { root: true });
        if (isCopy && data) {
          // 校验的结果,合并到adgroup显示
          const respCreativeReport = data.creative_report || []; // 返回必须和batchInfo数组一样长度
          for (let k = 0; k < batchInfo.length; k++) {
            const itemx = Object.assign({}, batchInfo[k]);
            const num = itemx.num || '';
            // 更新adgroup的 ad_id， creative_status
            const respItem = respCreativeReport[num] || {}; // 根据num 找到creative,合并到adgroup
            if (Object.keys(respItem).length > 0) {
              batchInfo[k] = {
                ...itemx,
                ...respItem,
              };
            }
          }
          publishReport.adgroup = [...batchInfo];
          if (isCopyCreative) {
            const { copyNumber } = rootState.creative.create;
            publishReport.ad = batchInfo.reduce((r, v) => {
              for (let i = 0; i < copyNumber; i++) {
                r.push(v);
              }
              return r;
            }, []);
          } else {
            publishReport.ad = [...batchInfo];
          }
        }
        finalData = data;
        publishReport.finalData = finalData;
      } catch (e) { // 全部失败的时候线上失败原因
        for (let k = 0; k < batchInfo.length; k++) {
          batchInfo[k].creative_msg = e?.msg || '';
        }
        publishReport.adgroup = [...batchInfo];
        publishReport.ad = [...batchInfo];
        return {
          status: false, item: 'ad', report: publishReport, rejectCode: e?.code,
        };
      }
      // split-test部分不在平台后端落库的数据需要落到数据侧
      // todo: edit的split现在有问题，先不做
      if (rootGetters['campaign/adgroup/useSplitTest'] && (rootGetters['campaign/adgroup/isCreate'] || isCopy)) {
        try {
          const splitTestEstimateVars = state.adgroup.splitTestAudienceEstimate;
          const realPeople = +splitTestEstimateVars[1].count === 0
            ? splitTestEstimateVars[0].count : Math.min(splitTestEstimateVars[0].count, splitTestEstimateVars[1].count);
          const realSamplePeople = +splitTestEstimateVars[1].sample_count === 0
            ? splitTestEstimateVars[0].sample_count : Math.min(splitTestEstimateVars[0].sample_count, splitTestEstimateVars[1].sample_count);
          let realBudget = state.adgroup.adgroupData.budget;
          if (state.adgroup.adgroupData.budget_mode === 0) {
            const startTime = moment(state.adgroup.adgroupData.start_time);
            const endTime = moment(state.adgroup.adgroupData.end_time);
            const diffDays = Math.ceil(endTime.diff(startTime, 'days', true)); // 计算天数差，不满一天按一天算
            realBudget *= diffDays;
          }
          const data = {
            campaign_id: campaignId,
            suggest_budget: state.adgroup.suggest_budget,
            power: state.adgroup.power,
            real_budget: +realBudget,
            reach_people: realPeople,
            sample_people: realSamplePeople,
          };
          await request.post(apis.splittest.save, data);
        } catch (e) {
          // 上报数据侧失败也不会影响创编流程
        }
      }
      return {
        status: true,
        item: 'all',
        report: publishReport,
      };
    },

    // R&F 提交订单、创建 Adgroup
    async createRFOrder(store, {
      isCopy,
    }) {
      const {
        state, dispatch,
      } = store;
      let campaignId = '';
      let campaignName = '';
      const publishReport = {
        campaign: {},
        adgroup: [],
        ad: [],
      };
      campaignId = state.adgroup.campaign_id || '';
      const campaign_coming_source_type = comingSourceType.CREATE_CAMPAIGN;
      const campaignFormData = state.adcampaign.campaignSaved || {};
      campaignName = campaignFormData.campaign_name || '';
      publishReport.campaign = {
        campaign_name: campaignName || '',
        campaign_id: campaignId || '',
        status: 1,
        msg: '',
      };
      let useExistedCampaign = true;
      // 第 1 步 campaign 数据提交 ==>
      // 当没有 campaignId 的时候，请求 campaign 新建的接口
      if (!campaignId) {
        // 没有campaignId时，RF复制视为使用新建campaign复制adg
        useExistedCampaign = false;
        try {
          const resp = await dispatch('adcampaign/createCampaign', { ...campaignFormData, coming_source_type: campaign_coming_source_type });
          const { data } = resp;
          if (!data || !data.campaign_id) {
            if (resp.code !== 4) {
              return { status: false, report: publishReport };
            }
          }
          campaignId = data.campaign_id;
          publishReport.campaign_id = campaignId;
          // campaign 创建成功，把 id 写进 store，以防 ad/create 时库存侧异常，adgroup 需要多次尝试创建
          await dispatch('adgroup/setCampaignID', campaignId);
        } catch (e) {
          return { status: false, report: publishReport, rejectCode: e?.message };
        }
      }
      // 第 2 步 ===>
      // 提交新建的单个计划
      const batchInfo = [];

      try {
        let adg_coming_source_type = comingSourceType.CREATE_AD_GROUP;
        if (isCopy && !useExistedCampaign) {
          adg_coming_source_type = comingSourceType.COPY_AD_GROUP_TO_NEW_CAMPAIGN;
        } else if (isCopy && useExistedCampaign) {
          adg_coming_source_type = comingSourceType.COPY_AD_GROUP_TO_EXISTED_CAMPAIGN;
        }
        const adgroupData = { ...state.adgroup.adgroupData } || {}; // 已经合并完成的数据
        if (adgroupData.language_list.length && adgroupData.language_list[0] === 'all') {
          adgroupData.language_list = [];
        }
        if (adgroupData.age.length && adgroupData.age[0] === 'ALL') {
          adgroupData.age = [];
        } else {
          adgroupData.age = formatAge(adgroupData.age);
        }
        adgroupData.ac = formatAc(adgroupData.ac);
        adgroupData.platform = formatPlatForm(adgroupData.platform);


        delete adgroupData.splitTestTarget;
        delete adgroupData.ad_id;

        adgroupData.campaign_id = campaignId;
        publishReport.adgroupData = { // 建议出价埋点需要用着两个
          bid: adgroupData.bid,
          cpa_bid: adgroupData.cpa_bid,
        };
        // 删除searchAds的字段，RF不支持searchAds
        delete adgroupData.search_delivery_type;
        const adgroupResp = await dispatch('adgroup/submitCreateRFAdgroup',
          { batch_info: batchInfo, base_info: { ...adgroupData, coming_source_type: adg_coming_source_type } });
        return {
          status: true, data: adgroupResp.data, report: publishReport, resp: adgroupResp,
        };
      } catch (e) {
        if (e && e.code) {
          return e;
        }
        return { status: false, report: publishReport };
      }
    },

    // 创建 plan | version
    async createPlanVersion({ state, dispatch }) {
      // format adgroup
      const adgroupData = {
        ...state.adgroup.adgroupData,
      } || {};
      if (adgroupData.language_list.length && adgroupData.language_list[0] === 'all') {
        adgroupData.language_list = [];
      }
      if (adgroupData.age.length && adgroupData.age[0] === 'ALL') {
        adgroupData.age = [];
      } else {
        adgroupData.age = formatAge(adgroupData.age);
      }
      adgroupData.ac = formatAc(adgroupData.ac);
      adgroupData.platform = formatPlatForm(adgroupData.platform);

      delete adgroupData.splitTestTarget;
      delete adgroupData.ad_id;

      // format version
      const {
        campaign_planner_version_name,
        campaign_planner_plan_id,
      } = adgroupData;
      const versionData = {
        campaign_planner_version_name,
        campaign_planner_plan_id,
      };
      delete adgroupData.campaign_planner_version_name;
      delete adgroupData.campaign_planner_plan_id;

      // create plan
      if (!versionData.campaign_planner_plan_id) {
        const { data } = await dispatch('efficientTool/submitCreatePlan', {
          campaign_planner_plan_name: versionData.campaign_planner_version_name,
        }, { root: true });

        if (!data || !data.campaign_planner_plan_id) {
          return;
        }
        versionData.campaign_planner_plan_id = data.campaign_planner_plan_id;
      }
      // create version
      const res = await dispatch('efficientTool/submitCreateVersion', {
        ...versionData,
        base_info: adgroupData,
      }, {
        root: true,
      });
      return {
        campaign_planner_version_id: res?.data?.campaign_planner_version_id,
        campaign_planner_plan_id: versionData.campaign_planner_plan_id,
      };
    },

    // 更新 version
    async updatePlanerVersion({ dispatch }, { base_info }) {
      let data = {};
      const {
        campaign_planner_version_name,
        campaign_planner_plan_id,
        campaign_planner_version_id,
      } = base_info;
      const versionData = {
        campaign_planner_version_name,
        campaign_planner_plan_id,
        campaign_planner_version_id,
      };
      delete base_info.campaign_planner_version_name;
      delete base_info.campaign_planner_plan_id;
      delete base_info.campaign_planner_version_id;
      try {
        data = await dispatch('efficientTool/submitUpdateVersion', {
          ...versionData,
          base_info,
        }, {
          root: true,
        });
        return data;
      } catch (err) {
        throw new Error(err);
      }
    },

    // 重算期间轮询重试
    async reSubmitRFOrder(store, campaign_id) {
      const {
        state, dispatch,
      } = store;
      const publishReport = {
        campaign: {},
        adgroup: [],
        ad: [],
      };
      let campaignId = '';
      campaignId = state.adgroup.campaign_id || campaign_id;
      const batchInfo = [];

      try {
        const adgroupData = { ...state.adgroup.adgroupData } || {}; // 已经合并完成的数据
        if (adgroupData.language_list.length && adgroupData.language_list[0] === 'all') {
          adgroupData.language_list = [];
        }
        if (adgroupData.age.length && adgroupData.age[0] === 'ALL') {
          adgroupData.age = [];
        } else {
          adgroupData.age = formatAge(adgroupData.age);
        }
        adgroupData.ac = formatAc(adgroupData.ac);
        adgroupData.platform = formatPlatForm(adgroupData.platform);


        delete adgroupData.splitTestTarget;
        delete adgroupData.ad_id;

        adgroupData.campaign_id = campaignId;
        publishReport.adgroupData = { // 建议出价埋点需要用着两个
          bid: adgroupData.bid,
          cpa_bid: adgroupData.cpa_bid,
        };
        const adgroupResp = await dispatch('adgroup/submitCreateAdgroup', { batch_info: batchInfo, base_info: adgroupData });
        return {
          status: true, data: adgroupResp.data, report: publishReport, resp: adgroupResp,
        };
      } catch (e) {
        return { status: false, report: publishReport, rejectCode: e?.message };
      }
    },
    async createSimplifiedSmbCreative(store, {
      creativeMaterialMode,
      inventory_flow,
      objective_type,
      fake_ad_ids,
      fake_campaign_id,
      fake_ad_group_id,
      inventory_flow_type,
    }) {
      const { rootGetters } = store;
      const COMING_SOURCE_TYPE_CREATE = 1;
      const creativeData = {
        creative_info: rootGetters['creative/create/creativeInfo'],
        creative_material_mode: creativeMaterialMode, // 与adgroup层级的取值保持一致
        fake_ad_ids,
        inventory_flow,
        coming_source_type: COMING_SOURCE_TYPE_CREATE,
        objective_type,
        inventory_flow_type,
        risk_info: tool.getRiskInfo(),
        struct_version: 1,
        ...rootGetters['creative/playable-card-form/formData'], // 试玩表单贡献的提交参数
      };
      creativeData.playable_url = creativeData.playable_url[0];
      const params = {
        version: 1,
        draft_json: creativeData,
      };
      const { check_result = {} } = await updateAndCheckUserCreativeDraft(params);
      const { ad_and_creative_ids = [] } = check_result;
      const [fake_ad_creative_id = ''] = ad_and_creative_ids;
      // 多创意同时提交时，后端只返回一个fake_ad_creative_id，后端自动会去匹配到同时提交的所有创意，前端无需特殊处理
      const submitParams = { fake_campaign_id, fake_ad_group_id, fake_ad_creative_id };
      const originResult = await submitDraftAndSaved(submitParams);
      const result = submitResultAdapt(originResult);
      return result;
    },
    async createRFCreative(store,
      {
        isCopy = false,
        isCopyCreative = false,
        isProcedural = false,
        creativeMaterialMode,
        isNewStructure,
        creativeInfoWithCta,
      }) {
      const ad_coming_source_type = comingSourceType.CREATE_AD;
      const {
        state, dispatch, rootState, rootGetters, commit,
      } = store;
      const publishReport = {
        campaign: {},
        adgroup: [],
        ad: [],
      };
      let batchInfo = [];
      const creativeBatchInfo = [];
      if (isCopy) {
        batchInfo = [...state.adgroup.batchInfo] || [];
      }
      const { inventory_flow: inventoryFlow, objective_type: objectiveType } = state.adgroup;
      const adIds = [state.adgroup.rf_ad_id];
      let creativeData = {
        ad_ids: adIds,
        inventory_flow: inventoryFlow,
        objective_type: objectiveType,
        coming_source_type: ad_coming_source_type, // 记录来源
        creative_material_mode: creativeMaterialMode, // 与adgroup层级的取值保持一致
        ...rootGetters['creative/playable-card-form/formData'], // 试玩表单贡献的提交参数
      };
      // 自定义创意
      if (!isProcedural) {
        if (rootGetters['campaign/adgroup/useCreativeSplitTest']) {
          const batchInfoWithoutPlayableUrl = rootGetters['creative/create/batchInfo'];
          // 为batchInfo挂上playableUrl
          creativeData.batch_info = batchInfoWithoutPlayableUrl.map((item, index) => {
            const playableUrlList = creativeData.playable_url;
            return { ...item, playable_url: playableUrlList[index] };
          });
        } else {
          creativeData.creative_info = isCopyCreative
            ? rootGetters['creative/create/copyCreativeInfo']
            : rootGetters['creative/create/creativeInfo'];

          Object.keys(creativeInfoWithCta).forEach((materialType) => {
            if (creativeInfoWithCta[materialType] && creativeInfoWithCta[materialType].length > 0) {
              creativeInfoWithCta[materialType].forEach((item, index) => {
                _.set(creativeData, `creative_info.${materialType}[${index}].call_to_action`, item.call_to_action);
                _.set(creativeData, `creative_info.${materialType}[${index}].call_to_action_id`, item.call_to_action_id);
              });
            }
          });
        }
      } else {
        // 程序化创意
        creativeData = {
          ...creativeData,
          ...rootGetters['creative/procedural-creative-form/formData'],
          struct_version: isNewStructure ? 1 : 0,
        };
      }
      if (isCopy) {
        creativeData.batch_info = creativeBatchInfo;
      }
      // 如果没有使用 creative 类型 split test，
      // 则应将待提交数据的playable_url参数从数组变为数组第一个元素
      // 因为split test在vuex中按照数组存储
      if (!rootGetters['campaign/adgroup/useCreativeSplitTest']) {
        creativeData.playable_url
          && (creativeData.playable_url = creativeData.playable_url[0]);
      } else {
        // 如果使用 creative 类型 split test，
        // 则将待提价数据外层playable_url参数清除，
        // playable_url已被放置在batchInfo中
        creativeData.playable_url = undefined;
      }
      let finalData = null;
      try {
        const { data } = await dispatch('creative/create/uploadAds', creativeData, { root: true });
        if (isCopy && data) {
          // 校验的结果,合并到adgroup显示
          const respCreativeReport = data.creative_report || []; // 返回必须和batchInfo数组一样长度
          for (let k = 0; k < batchInfo.length; k++) {
            const itemx = Object.assign({}, batchInfo[k]);
            const num = itemx.num || '';
            // 更新adgroup的 ad_id， creative_status
            const respItem = respCreativeReport[num] || {}; // 根据num 找到creative,合并到adgroup
            if (Object.keys(respItem).length > 0) {
              batchInfo[k] = {
                ...itemx,
                ...respItem,
              };
            }
          }
          publishReport.adgroup = [...batchInfo];
          if (isCopyCreative) {
            const { copyNumber } = rootState.creative.create;
            publishReport.ad = batchInfo.reduce((r, v) => {
              for (let i = 0; i < copyNumber; i++) {
                r.push(v);
              }
              return r;
            }, []);
          } else {
            publishReport.ad = [...batchInfo];
          }
        }
        finalData = data;
        publishReport.finalData = finalData;
        publishReport.creativesPostData = creativeData;
      } catch (e) { // 全部失败的时候线上失败原因
        for (let k = 0; k < batchInfo.length; k++) {
          batchInfo[k].creative_msg = e?.msg || '';
        }
        publishReport.adgroup = [...batchInfo];
        publishReport.ad = [...batchInfo];
        return {
          status: false, item: 'ad', report: publishReport, rejectCode: e?.code,
        };
      }
      commit(types.SET_RF_AD_GROUP_ID, '');
      await dispatch('adgroup/setCampaignID', '');
      return {
        status: true,
        item: 'all',
        report: publishReport,
      };
    },

    /**
     * 获取AB实验结果数据
     * @param {String} data campaignId
     */
    getSplittestResult(store, data) {
      return request.get(apis.splittest.result, data);
    },
    /**
     * 获取AB实验结果variable和objective数据
     * @param {String} data campaignId
     */
    getSplittestDetail(store, data) {
      return request.get(apis.splittest.detail, data);
    },
    getSplittestAdDetail(store, data) {
      return request.get(apis.splittest.adDetail, {
        ad_id: data,
      });
    },
    /**
     * 获取AB实验披露指标数据
     * @param {Array} data ad_ids
     */
    getSplittestMetrics(store, data) { // TODO-kad 待确认，query是否只需传ad_ids字段
      return request.post(apis.splittest.newMetrics, data);
    },
    /**
     * 修改bid/budget时提醒需要同步修改的列表
     * 该接口后端要下线
     * @param {Object} data {"ad_ids": Array}
     */
    getSplittestExcludeList(store, data) {
      return request.post(apis.splittest.exclude, data);
    },
    getOptimizeGoal(store, data) {
      return request.get(apis.splittest.optimizeGoal, data);
    },
  },
};
